import { gql } from '@apollo/client';

export const SETTINGS = gql`
  fragment Settings on FrequencyManagementSettings {
    mode
    period
    minAllowed
    maxAllowed
    frequencyOptimizationDetails
    frequencyOptimizationDetailsUpdatedAt
  }
`;

export const ALL_MEDIUM_FIELDS = gql`
  ${SETTINGS}

  fragment AllMediumFields on FrequencyManagementSettingsForMedium {
    isConfiguredForSending
    settings {
      ...Settings
    }
    messageTypes {
      id
      name
      frequencyManagement {
        ignoreCap
        settings {
          ...Settings
        }
      }
      messageChannel {
        name
      }
    }
  }
`;
